import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import SalesPerformance from "../../../containers/modules/chart/sales-performance";

export default function SalesPerformanceRoutes(props) {
  const { authUser } = props;
  return (
    <Route
      path="sales-performance"
      index
      element={
        <AccessControl
          name={"Sales Performance Chart Show"}
          auth={authUser}
          component={() => <SalesPerformance />}
        />
      }
    ></Route>
  );
}
